export default __webpack_public_path__ + "static/media/team-building.c7976454.png";